import axios from "axios";
import { RequestConnection } from "../../models/RequestConnection";
import { Query } from "../../interfaces";
import ConnectionClient from "../../shared/api-client";

export const saveRequest = async (request: RequestConnection) => {
  const client = new ConnectionClient();
  const result = await client.api.post(
    `${process.env.REACT_APP_API_HOST}/items/connection_request`,
    {
      content: request.content,
      organization_name: request.organization_name,
      owner_email: request.to?.email,
      request_type: request.request_type,
      actor_type: request.actor_type?.id,
      city: request.city,
      cityRaw: request.cityRaw,
    }
  );

  return result.data;
};

export const changeRequestStatus = async (request: RequestConnection) => {
  const client = new ConnectionClient();

  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/connection_request/${request.id}`,
    {
      request_status: request.status,
    }
  );

  return result.data;
};

export const reject = async (request: RequestConnection) => {
  const client = new ConnectionClient();
  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/connection_request`,
    {
      content: request.content,
    }
  );
  return result.data;
};

export const setOwn = async (id: string, userId: string) => {
  const client = new ConnectionClient();
  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/connection_request/${id}`,
    {
      owner: userId,
    }
  );

  return result.data;
};

export const sendNotification = async (data: RequestConnection) => {
  const result = await axios.post(
    `${process.env.REACT_APP_API_HOST}/connection-request/invite`,
    data
  );
  return result.data;
};

export const sendNotificationConfirm = async (data: RequestConnection) => {
  const result = await axios.post(
    `${process.env.REACT_APP_API_HOST}/connection-request/invite-accepted`,
    data
  );
  return result.data;
};

export const loadData = async (
  collection: string,
  query: Query,
  page: number = 1,
  limit: number = 5
) => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${process.env.REACT_APP_API_HOST}/items/${collection}?meta=${
      query.meta ? query.meta : `total_count&page=${page}&limit=${limit}`
    }&${Object.values(query.filter).join("")}&fields=*.*.*&deep=true`
  );

  return result.data;
};
